// extracted by mini-css-extract-plugin
module.exports = {"popover__spacer":"Select_popover__spacer__3kL6H","placeholder":"Select_placeholder__1zibc","button__title":"Select_button__title__24KQE","icon":"Select_icon__3698Y"};